export const PAYMENT_CALLBACK_DISCRIMINATOR = {
  VOUCHER: 'voucher',
  WOMPI_SUCCESS: 'wompi-success',
  INSWITCH_SUCCESS: 'inswitch-success',
  INSWITCH_ERROR: 'inswitch-error',
} as const;
